module.exports = __webpack_public_path__ + "static/sponsorship_img-08-b-6487d17cf76654e3650482f8f21b38b9.jpg";